/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCategoryLookupDto
 */
export interface CreateCategoryLookupDto {
    /**
     * Unique category code
     * @type {string}
     * @memberof CreateCategoryLookupDto
     */
    code: string;
    /**
     * Category name in English
     * @type {string}
     * @memberof CreateCategoryLookupDto
     */
    nameEn: string;
    /**
     * Category name in Arabic
     * @type {string}
     * @memberof CreateCategoryLookupDto
     */
    nameAr?: string;
    /**
     * Category description
     * @type {string}
     * @memberof CreateCategoryLookupDto
     */
    description?: string;
    /**
     * Category image URL
     * @type {string}
     * @memberof CreateCategoryLookupDto
     */
    imageUrl?: string;
    /**
     * Whether the category is active
     * @type {boolean}
     * @memberof CreateCategoryLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display (1-1000)
     * @type {number}
     * @memberof CreateCategoryLookupDto
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the CreateCategoryLookupDto interface.
 */
export function instanceOfCreateCategoryLookupDto(value: object): value is CreateCategoryLookupDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    return true;
}

export function CreateCategoryLookupDtoFromJSON(json: any): CreateCategoryLookupDto {
    return CreateCategoryLookupDtoFromJSONTyped(json, false);
}

export function CreateCategoryLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCategoryLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function CreateCategoryLookupDtoToJSON(value?: CreateCategoryLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
    };
}

